import axios from "../axiosPlugin.js";

export const getAccountSetting = (data, loading = true) => {
  return axios({
    url: "/api/setting/getAccountSetting",
    method: 'get',
    data: {
      data,
      loading,
    },
  })
};

export const updateAccountSetting = (data, loading = true) => {
  return axios({
    url: "/api/setting/updateAccountSetting?passwordPeriod=" + data.passwordPeriod,
    method: 'put',
    data: {
      data: {},
      loading,
    },
  })
};

export const getGlobalSetting = (data, loading = true) => {
  return axios({
    url: "/api/setting/getGlobalSetting",
    method: 'get',
    data: {
      data,
      loading,
    },
  })
};

export const updateGlobalSetting = (data, loading = true) => {
  return axios({
    url: "/api/setting/updateGlobalSetting",
    method: 'put',
    data: {
      data,
      loading,
    },
  })
};

export const getOnlineTicketingSetting = (data, loading = true) => {
  return axios({
    url: "/api/setting/getOnlineTicketingSetting",
    method: 'get',
    data: {
      data,
      loading,
    },
  })
};

export const addOnlineTicketingSetting = (data, loading = true) => {
  return axios({
    url: "/api/setting/addOnlineTicketingSetting",
    method: 'post',
    data: {
      data,
      loading,
    },
  })
};

export const openOnlineTicketingSetting = (data, loading = true) => {
  return axios({
    url: "/api/setting/openOnlineTicketingSetting",
    method: 'put',
    data: {
      data,
      loading,
    },
  })
};

export const getTicketTypeService = data => {
  return axios({
    url: "/api/ticketType/list",
    method: "get",
    data: {
      data
    },
  });
};

export const createTicketTypeService = data => {
  return axios({
    url: "/api/ticketType/create",
    method: "post",
    data: {
      data
    },
  });
};

export const updateTicketTypeService = data => {
  return axios({
    url: "/api/ticketType/update",
    method: "post",
    data: {
      data
    },
  });
};

export const deleteTicketTypeService = data => {
  return axios({
    url: "/api/ticketType/delete/" + data.id,
    method: "get",
    data: {},
  });
};

export const getTicketTypeDetailService = data => {
  return axios({
    url: "/api/ticketType/detail/" + data.id,
    method: "get",
    data: {},
  });
};
